/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = WhatsAppDialog
 *
 * 1 = Lead
 *
 * 2 = Deal
 *
 * 3 = EnquiryCRM
 *
 * 4 = PayRequest
 *
 * 5 = Appraisal
 *
 * 6 = Appointment
 */
export enum ContactDialogReferenceType {
  WhatsAppDialog = 0,
  Lead = 1,
  Deal = 2,
  EnquiryCRM = 3,
  PayRequest = 4,
  Appraisal = 5,
  Appointment = 6,
}
